import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as deviceService from "../deviceService";
import * as modalDataService from "./modalDataService";

function DualListEventSelect({ deviceTypeId, events, selectedEvents, enableSyslogProcessing }) {
    const disabled = !enableSyslogProcessing;
    const [eventList, setEventList] = useState([]);
    const [selectedFromEvents, setSelectedFromEvents] = useState([]);
    const [selectedFromChosen, setSelectedFromChosen] = useState([]);

    useEffect(() => {
        deviceService.eventsList();
    }, [deviceTypeId]);

    useEffect(() => {
        setEventList(
            (events || []).filter((event) => event.deviceType && event.deviceType.id === Number(deviceTypeId))
        );
    }, [deviceTypeId, events]);

    useEffect(() => {
        setSelectedFromEvents((current) => current.filter((id) => !selectedEvents.find((event) => event.id === id)));
        setSelectedFromChosen((current) => current.filter((id) => selectedEvents.find((event) => event.id === id)));
    }, [selectedEvents]);

    useEffect(() => {
        if (disabled) {
            setSelectedFromEvents([]);
            setSelectedFromChosen([]);
        }
    }, [disabled]);

    const availableEvents = useMemo(() => {
        return eventList.filter((event) => !selectedEvents.find((selectedEvent) => selectedEvent.id === event.id));
    }, [eventList, selectedEvents]);

    const toggleFromEvents = (eventId) => {
        if (disabled) {
            return;
        }

        setSelectedFromEvents((current) => (
            current.includes(eventId)
                ? current.filter((id) => id !== eventId)
                : [...current, eventId]
        ));
    };

    const toggleFromChosen = (eventId) => {
        if (disabled) {
            return;
        }

        setSelectedFromChosen((current) => (
            current.includes(eventId)
                ? current.filter((id) => id !== eventId)
                : [...current, eventId]
        ));
    };

    const moveToSelected = () => {
        if (disabled || !selectedFromEvents.length) {
            return;
        }

        const eventsToAdd = availableEvents.filter((event) => selectedFromEvents.includes(event.id));
        modalDataService.selectAllEvents([...selectedEvents, ...eventsToAdd]);
        setSelectedFromEvents([]);
    };

    const moveToEvents = () => {
        if (disabled || !selectedFromChosen.length) {
            return;
        }

        modalDataService.selectAllEvents(
            selectedEvents.filter((event) => !selectedFromChosen.includes(event.id))
        );
        setSelectedFromChosen([]);
    };

    return (
        <div className={`modal-v2-step3-duallist ${disabled ? "is-disabled" : ""}`}>
            <div className="modal-v2-step3-list-card">
                <div className="modal-v2-step3-list-header">
                    <div className="modal-v2-step3-list-title">Events</div>
                </div>

                <div className="modal-v2-step3-list-body">
                    {availableEvents.length ? (
                        <ul className="modal-v2-step3-list">
                            {availableEvents.map((event) => {
                                const isSelected = selectedFromEvents.includes(event.id);

                                return (
                                    <li
                                        key={event.id}
                                        className={`modal-v2-step3-list-item ${isSelected ? "is-selected" : ""}`}
                                        onClick={() => toggleFromEvents(event.id)}
                                    >
                                        <span className={`modal-v2-step3-list-item-box ${isSelected ? "is-selected" : ""}`} />
                                        <span>{event.name}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <div className="modal-v2-step3-list-empty">No events available</div>
                    )}
                </div>
            </div>

            <div className="modal-v2-step3-controls">
                <button
                    type="button"
                    className="modal-v2-step3-control-btn"
                    onClick={moveToSelected}
                    disabled={disabled || !selectedFromEvents.length}
                    aria-label="Move selected events to selected events"
                >
                    &gt;
                </button>

                <button
                    type="button"
                    className="modal-v2-step3-control-btn"
                    onClick={moveToEvents}
                    disabled={disabled || !selectedFromChosen.length}
                    aria-label="Move selected chosen events back to events list"
                >
                    &lt;
                </button>
            </div>

            <div className="modal-v2-step3-list-card">
                <div className="modal-v2-step3-list-header">
                    <div className="modal-v2-step3-list-title">Selected Events</div>
                </div>

                <div className="modal-v2-step3-list-body">
                    {selectedEvents.length ? (
                        <ul className="modal-v2-step3-list">
                            {selectedEvents.map((event) => {
                                const isSelected = selectedFromChosen.includes(event.id);

                                return (
                                    <li
                                        key={event.id}
                                        className={`modal-v2-step3-list-item is-selected ${isSelected ? "is-marked" : ""}`}
                                        onClick={() => toggleFromChosen(event.id)}
                                    >
                                        <span className={`modal-v2-step3-list-item-box ${isSelected ? "is-marked" : "is-selected"}`} />
                                        <span>{event.name}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <div className="modal-v2-step3-list-empty">No events selected</div>
                    )}
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("DualListEventSelect mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        events: addDeviceModal.events || [],
        selectedEvents: addDeviceModal.selectedEvents || [],
        enableSyslogProcessing: addDeviceModal.enableSyslogProcessing,
        deviceTypeId: addDeviceModal.deviceTypeId
    };
}

export default connect(mapStateToProps)(DualListEventSelect);
